<template>
  <div class="project-create jrtt-ad-create-container">
    <div class="text-right">
      <el-button type="primary" plain size="mini" @click="openTemplateDialog('ad')">保存模板</el-button>
      <el-button size="mini" type="success" @click="openTemplateList('ad')">读取模板</el-button>
    </div>
    <div
      v-for="(item, key) in ad_form_config"
      :key="key"
      style="margin: 20px 0"
    >
      <div v-show="!item.hidden">
        <el-divider content-position="left">
          <h2>{{ item.title }}</h2>
        </el-divider>
        <app-form
          :ref="'ad_form'"
          :form-data="item.config"
          :submit-request="onSubmit"
          :is-show-button="false"
          default-label-width="120px"
        >
          <template #custom="{form_item, form_key}">
            <!-- 不存在组件类型 -->
            <div v-if="!form_item.type">
              <!-- 素材 -->
              <div v-if="form_key === 'material'">
                <el-button icon="el-icon-video-camera-solid" @click="openMaterialBox('video')">添加视频</el-button>
                <el-button icon="el-icon-picture" @click="openMaterialBox('image')">添加图片</el-button>
                <span style="margin-left: 10px">{{ form_item.value.videos.length + form_item.value.images.length }}/{{ form_item.limit }}</span>
                <el-link
                  v-if="form_item.value.videos.length || form_item.value.images.length"
                  style="float: right"
                  type="primary"
                  @click="form_item.value[form_item.value.tab + 's'] = []"
                >清空</el-link>
                <material-list
                  v-model="form_item.value"
                  @replace-cover="replaceCover"
                />

                <!-- 素材弹框 -->
                <material-box
                  v-if="form_item.is_open"
                  advertiser="jrtt"
                  :is-open="form_item.is_open"
                  :type="form_item.box_type"
                  :temp-material="form_item.temp_material"
                  :ad_form_config-basic-config="ad_basic_config"
                  @confirm="materialConfirm"
                  @cancel="materialCancel(form_item)"
                />
              </div>

              <!-- 产品图 -->
              <div v-if="form_key === 'image_ids'">
                <el-button icon="el-icon-picture" @click="openMaterialBox('image', form_item)">添加图片</el-button>
                <span style="margin-left: 10px">{{ form_item.value.images.length }}/{{ form_item.limit }}</span>
                <el-link
                  v-if="form_item.value.images.length"
                  style="float: right"
                  type="primary"
                  @click="form_item.value.images = []"
                >清空</el-link>
                <material-list
                  v-model="form_item.value"
                />

                <!-- 产品图片素材弹框 -->
                <material-box
                  v-if="form_item.is_open"
                  :is-open="form_item.is_open"
                  :type="form_item.box_type"
                  :temp-material="form_item.temp_material"
                  :ad_form_config-basic-config="ad_basic_config"
                  :material-format-id="22"
                  @confirm="productInfoConfirm"
                  @cancel="materialCancel(form_item)"
                />
              </div>

              <!-- 标题 -->
              <div v-else-if="form_key === 'title'">
                <title-list :title-data="form_item.value" />
              </div>

              <div v-else>
                {{ form_item.type }}
              </div>
            </div>
            <!-- 存在组件类型，额外组件类型 -->
            <div v-else>
              <!-- 输入框列表 -->
              <div v-if="form_item.type === 'input-list'">
                <input-list :input-value="form_item.value" v-bind="form_item.props" />
              </div>

              <!-- 图片上传列表 -->
              <div v-if="form_item.type === 'image-list'">
                <image-list :advertiser-id="ad_form_config.basic_form.config.advertiser_id.value" :image-list="form_item.value" />
              </div>

              <el-button
                v-if="form_key === 'web_url_material_list' || form_key === 'external_url_material_list'"
                class="fr"
                type="primary"
                @click="openLandingPage(form_key, form_item.label)"
              >
                选择已有
              </el-button>

              <!-- 落地页在编辑广告且推广目标是小游戏时显示提示信息 -->
              <div v-if="form_key === 'external_url_material_list' && is_edit && project_info.landing_type === 'MICRO_GAME'">
                <el-alert :closable="false" title="只能更换相同小游戏ID的落地页" type="info" />
              </div>
              <div v-if="form_key === 'mini_program_info_url'" class="ml-10">
                <el-button type="primary" @click="openMiniProgramInfoUrl()">选择小游戏链接</el-button>
              </div>
            </div>
          </template>
        </app-form>
      </div>
    </div>

    <div class="floor-button">
      <el-button @click="onCancelForm">取消</el-button>
      <el-button :loading="is_loading" type="primary" @click="onConfirmForm">确定</el-button>
    </div>

    <table-box
      v-if="table_box_params.is_show"
      :is-open="table_box_params.is_show"
      :get-table-data="table_box_params.getTableData"
      :pull-data="table_box_params.pullTableData"
      :tablep="table_box_params.tablep"
      :table-list-key="table_box_params.configs"
      :table-box-key="table_box_params.key"
      :title-name="table_box_params.name"
      @confirm="tableBoxConfirm"
      @cancel="tableBoxCancel"
    />

    <!-- 模板列表 -->
    <template-list
      v-if="template_list_config.is_show"
      :template-list-config="template_list_config"
      @confirm="applicationTemplate"
    />
    <!-- 模板弹框 -->
    <template-dialog
      v-if="template_dialog_config.is_show"
      :template-config="template_dialog_config"
      @confirm="confirmTemplateDialog"
    />
    <el-dialog
      v-if="mini_program_info_url_dialog_config.is_show"
      :visible.sync="mini_program_info_url_dialog_config.is_show"
      v-bind="mini_program_info_url_dialog_config.dialog_props"
    >
      <mini-program-info-url
        v-if="mini_program_info_url_dialog_config.is_show"
        v-bind="mini_program_info_url_dialog_config.getters.getProps()"
        @confirm="miniProgramInfoUrlConfirm"
      />
    </el-dialog>
  </div>
</template>

<script>
import { formDataAssign } from '@/tools/form';
import { createPromotionApi, updatePromotionApi, getPromotionInfoApi } from '@/api/promotion/jrtt';
import { getMediasListApi } from '@/api/medias';
import { getProjectSelectorApi, getProjectInfoApi } from '@/api/project/jrtt';
import AdvertisingResource from '@/api/advertising';
import TemplateResource from '@/api/template';
import NativeAnchor from '@/api/tool/nativeAnchor/jrtt';

const advertisingResource = new AdvertisingResource();
const templateResource = new TemplateResource();
const nativeAnchor = new NativeAnchor();

export default {
  components: {
    'app-form': () => import('@/components/app-form'),
    'title-list': () => import('./title-list'),
    'material-list': () => import('./material-list'),
    'material-box': () => import('@/components/material-box'),
    'input-list': () => import('./input-list'),
    'image-list': () => import('./image-list'),
    'table-box': () => import('./table-box'),
    'mini-program-info-url': () => import('@/views/superior/jrtt/components/mini-program-info-url'),
    'template-list': () => import('@/views/superior/jrtt/intelligence-create-plan/components/templateList.vue'),
    'template-dialog': () => import('@/views/superior/jrtt/intelligence-create-plan/components/templateDialog.vue'),
  },
  props: {
    /** 广告数据 */
    adData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      /** 模板列表配置 */
      template_list_config: {
        is_loading: false,
        is_show: false,
        type: '',
      },
      /** 模板弹窗配置 */
      template_dialog_config: {
        is_show: false,
        name: '',
        type: '',
        is_validate: true,
      },
      /** 表格弹框参数 */
      table_box_params: {
        // 是否显示
        is_show: false,
        // 搜索名称
        name: '',
        // 表格存储键值
        key: '',
        // 列表请求参数
        tablep: {},
        // 表头配置数组
        configs: [],
        // 获取表格数据接口
        getTableData: null,
      },
      ad_basic_config: {
        advertiser_ids: [],
        marketing_purpose: 'CONVERSION',
        landing_type: 'APP',
        put_category: 'STANDARD_DELIVERY',
        app_type: 'APP_ANDROID',
      },
      /** 是否显示加载 */
      is_loading: false,
      /** 提交广告参数 */
      ad_params: {},
      /** 项目信息 */
      project_info: {},
      /** 广告表单配置 */
      ad_form_config: {
        // 广告素材-表单配置
        basic_form: {
          title: '基础配置',
          config: {
            advertiser_id: {
              label: '广告主',
              type: 'select',
              options: [],
              value: '',
              props: {
                filterable: true,
              },
              rules: {
                required: true, message: '请选择广告主账号', trigger: ['change'],
              },
              on: {
                change: (val) => {
                  const { advertiser_id, project_id } = this.ad_form_config.basic_form.config;
                  if (val) {
                    project_id.value = '';
                    project_id.options = [];
                  }

                  this.getProjectSelector(advertiser_id.value);
                  this.getAwemeIdOptions(advertiser_id.value);
                },
              },
            },
            project_id: {
              label: '项目',
              type: 'select',
              options: [],
              value: '',
              props: {
                filterable: true,
              },
              rules: {
                required: true, message: '请选择项目', trigger: ['change'],
              },
              on: {
                change: (val) => {
                  const { mini_program_info_url } = this.ad_form_config.material_form.config.promotion_materials.children;
                  // 用户手动操作触发change事件时执行
                  val && (mini_program_info_url.value = '');
                  const { project_id } = this.ad_form_config.basic_form.config;
                  this.getProjectInfo(project_id.value);
                },
              },
            },
            name: {
              label: '广告名称',
              type: 'input',
              value: '',
              rules: {
                required: true, message: '请输入广告名称', trigger: ['change'],
              },
            },
            operation: {
              label: '广告状态',
              type: 'radio-group',
              value: 'DISABLE',
              isButton: true,
              options: [
                { label: '开启', value: 'ENABLE' },
                { label: '关闭', value: 'DISABLE' },
              ],
            },
          },
        },
        // 推广身份
        native_form: {
          title: '推广身份',
          config: {
            native_setting: {
              value: {},
              children: {
                promotion_identity: {
                  label: '推广身份',
                  type: 'radio-group',
                  isButton: true,
                  is_filter: true,
                  options: [
                    { label: '抖音号', value: 'TIKTOK' },
                    { label: '账户信息', value: 'ACCOUNT_INFO' },
                  ],
                  value: 'ACCOUNT_INFO',
                  rules: [
                    { required: true, message: '请选择推广身份', trigger: ['blur', 'change'] },
                  ],
                  on: {
                    change: () => {
                      const { promotion_identity, aweme_id } = this.ad_form_config.native_form.config.native_setting.children;
                      const { anchor_related_type } = this.ad_form_config.anchor_material_list_form.config;
                      const is_account = promotion_identity.value === 'ACCOUNT_INFO';
                      aweme_id.hidden = is_account;
                      anchor_related_type.disabled = is_account;
                      is_account && (anchor_related_type.value = 'OFF');
                      anchor_related_type.on.change();
                    },
                  },
                },
                aweme_id: {
                  label: '授权账号',
                  type: 'select',
                  hidden: true,
                  props: {
                    style: {
                      width: '200px',
                    },
                    loading: false,
                  },
                  value: '',
                  options: [],
                  rules: [
                    { required: true, message: '请选择授权账号', trigger: ['blur', 'change'] },
                  ],
                },
              },
            },
          },
        },
        // 广告素材-表单配置
        material_form: {
          title: '广告素材',
          config: {
            promotion_materials: {
              value: {},
              children: {
                material: {
                  label: '添加素材',
                  // 限制数量
                  limit: 10,
                  is_open: false,
                  box_type: 'video',
                  temp_material: null,
                  rules: {
                    required: true, trigger: [],
                    validator: (rule, value, callback) => {
                      const { material } = this.ad_form_config.material_form.config.promotion_materials.children;
                      const material_num = value.videos.length + value.images.length;
                      if (material_num === 0) {
                        callback(new Error('请选择素材'));
                      } else if (material_num > material.limit) {
                        callback(new Error('素材数量超出上限'));
                      } else {
                        callback();
                      }
                    },
                  },
                  value: {
                    videos: [],
                    images: [],
                    tab: 'video',
                  },
                },
                // 标题素材
                title: {
                  label: '标题',
                  is_open: false,
                  rules: [
                    {
                      required: true, message: '请选择标题', trigger: [],
                      validator: (rule, value, callback) => {
                        if (value.list.length === 0) {
                          callback(new Error('请选择标题'));
                        } else {
                          callback();
                        }
                      },
                    },
                  ],
                  value: {
                    list: [],
                  },
                },
                /** 小游戏链接 */
                mini_program_info_url: {
                  label: '小游戏链接',
                  type: 'input',
                  hidden: true,
                  value: '',
                  props: {
                    disabled: true,
                  },
                  rules: [
                    { required: true, message: '请选择小游戏链接', trigger: ['blur', 'change'] },
                  ],
                },
                /** 普通落地页链接素材 */
                external_url_material_list: {
                  label: '落地页',
                  type: 'input-list',
                  hidden: true,
                  value: [],
                  props: {
                    maxCount: 10,
                  },
                  rules: {
                    required: true, trigger: [],
                    validator: (rule, value, callback) => {
                      if (value.length === 0) {
                        callback(new Error('至少添加一个'));
                      } else {
                        callback();
                      }
                    },
                  },
                },
                /** Android应用下载详情页（用户点击广告中“立即下载”按钮以外的区域时所到达的页面），上限10个 */
                web_url_material_list: {
                  label: 'Android应用下载详情页',
                  type: 'input-list',
                  hidden: true,
                  value: [],
                  props: {
                    maxCount: 10,
                  },
                  rules: {
                    required: true, trigger: [],
                    validator: (rule, value, callback) => {
                      if (value.length === 0) {
                        callback(new Error('至少添加一个'));
                      } else {
                        callback();
                      }
                    },
                  },
                },
              },
            },
          },
        },
        // 产品信息
        product_info_form: {
          title: ' 产品信息',
          config: {
            product_info: {
              value: {},
              children: {
                titles: {
                  label: '产品名称',
                  type: 'input-list',
                  props: {
                    min: 1,
                    max: 20,
                  },
                  rules: {
                    required: true, trigger: [],
                    validator: (rule, value, callback) => {
                      if (value.length === 0) {
                        callback(new Error('产品名称至少添加一个'));
                      } else {
                        callback();
                      }
                    },
                  },
                  value: [],
                },
                image_ids: {
                  label: '产品主图',
                  // 限制数量
                  limit: 10,
                  is_open: false,
                  box_type: 'image',
                  temp_material: null,
                  value: {
                    images: [],
                    tab: 'image',
                  },
                  rules: {
                    required: true, trigger: [],
                    validator: (rule, value, callback) => {
                      if (value.images.length !== 0) {
                        callback();
                      } else {
                        callback(new Error('请选择产品主图'));
                      }
                    },
                  },
                },
                selling_points: {
                  label: '产品卖点',
                  type: 'input-list',
                  value: [],
                  props: {
                    min: 6,
                    max: 9,
                  },
                  rules: {
                    required: true, trigger: [],
                    validator: (rule, value, callback) => {
                      if (value.length === 0) {
                        callback(new Error('产品卖点至少添加一个'));
                      } else {
                        callback();
                      }
                    },
                  },
                },
              },
            },
            // 行动号召文案
            call_to_action_buttons: {
              label: '行动号召文案',
              type: 'input-list',
              value: [],
              props: {
                min: 2,
                max: 6,
              },
              rules: {
                required: true, trigger: [],
                validator: (rule, value, callback) => {
                  if (value.length === 0) {
                    callback(new Error('行动号召文案至少添加一个'));
                  } else {
                    callback();
                  }
                },
              },
            },
          },
        },
        // 出价运算
        budget_and_bid_form: {
          title: '广告预算与出价',
          hidden: false,
          config: {
            /**
             * 预算(出价方式为OCPM时，不少于300元；24小时内修改预算操作，不能超过20次，24小时是指自然天的24小时；单次修改预算幅度不能低于100元（增加或者减少）；修改后预算金额，不能低于当前已消费金额的105%，以整百单位向上取整；取值范围: ≥ 0
             */
            budget: {
              label: '预算',
              type: 'input-number',
              value: 0,
              props: {
                min: 300,
              },
              hidden: false,
            },
            /**
             * 目标转化出价/预期成本， 取值范围：0.1-10000元
             * 注意：当 bid_type = NO_BID时，不填写该字段，否则会报错
             */
            cpa_bid: {
              label: '目标转化出价',
              type: 'input-number',
              value: 0,
              hidden: false,
              props: {
                min: 0.1,
                max: 10000,
              },
            },
            /**
             * 深度优化出价，deep_bid_type = DEEP_BID_MIN 时必填。取值范围：0.1~10000元
             * 注意：当 bid_type = NO_BID时，不填写该字段，否则会报错
             */
            deep_cpabid: {
              label: '深度优化出价',
              type: 'input-number',
              hidden: true,
              value: '',
            },
            /**
             * 深度转化ROI系数, 范围(0,5]，精度：保留小数点后四位，当 deep_bid_type = ROI_COEFFICIENT 时必填
             * 注意：当 bid_type=NO_BID时，不填写该字段，否则会报错
             */
            roi_goal: {
              label: '深度转化ROI系数',
              type: 'input-number',
              hidden: true,
              value: '',
            },
          },
        },
        // 附加创意信息-表单配置
        additional_creative_info_form: {
          title: '附加创意信息',
          config: {
            /** 广告来源，字数限制：[2-10]（英文字符限制：[4-20]）当landing_type = LINK、MICRO_GAME、SHOP时必填  */
            source: {
              label: '广告来源',
              type: 'input',
              value: '',
              rules: {
                required: true,
                trigger: ['change'],
                validator: (rule, value, callback) => {
                  let len = 0;
                  for (let i = 0; i < value.length; i++) {
                    // 识别中文字符则长度+2，其余字符长度+1
                    if (value.charAt(i).match(/[\u4e00-\u9fa5]/g) != null) {
                      len += 2;
                    } else {
                      len += 1;
                    }
                  }
                  /** 字符长度为0且推广目标不是小游戏时允许通过验证 */
                  if (len === 0 && this.project_info.landing_type !== 'MICRO_GAME') {
                    callback();
                  } else if (len > 20 || len < 4) {
                    callback(new Error('字数限制：[2-10]（英文字符限制：[4-20]）'));
                  } else {
                    callback();
                  }
                },
              },
            },
          },
        },
        // 原生锚点
        anchor_material_list_form: {
          title: '原生锚点',
          config: {
            anchor_related_type: {
              label: '原生锚点',
              type: 'radio-group',
              value: 'OFF',
              isButton: true,
              disabled: true,
              options: [{
                label: '不启用',
                value: 'OFF',
              },
              {
                label: '自动生成',
                value: 'AUTO',
              },
              {
                label: '手动选择',
                value: 'SELECT',
                disabled: false,
              }],
              rules: [
                { required: true, message: '请选择原生锚点', trigger: ['blur', 'change'] },
              ],
              on: {
                change: () => {
                  const { anchor_related_type } = this.ad_form_config.anchor_material_list_form.config;
                  const { anchor_type, anchor_id } = this.ad_form_config.anchor_material_list_form.config.anchor_material_list.children;
                  const is_select = anchor_related_type.value === 'SELECT';
                  anchor_type.hidden = !is_select;
                  anchor_id.hidden = !is_select;
                },
              },
            },
            anchor_material_list: {
              value: {},
              children: {
                anchor_type: {
                  label: '锚点类型',
                  type: 'select',
                  hidden: true,
                  value: '',
                  props: {
                    placeholder: '请选择锚点类型',
                    filterable: true,
                    style: {
                      width: '200px',
                    },
                  },
                  options: [
                    { label: '应用下载-游戏', value: 'APP_GAME' },
                    { label: '应用下载-网服', value: 'APP_INTERNET_SERVICE' },
                    { label: '应用下载-电商', value: 'APP_SHOP' },
                    { label: '高级在线预约', value: 'ONLINE_SUBSCRIBE' },
                  ],
                  rules: [
                    { required: true, message: '请选择锚点类型', trigger: ['blur', 'change'] },
                  ],
                  on: {
                    change: () => {
                      const { anchor_type, anchor_id } = this.ad_form_config.anchor_material_list_form.config.anchor_material_list.children;
                      const { advertiser_id } = this.ad_form_config.basic_form.config;
                      if (anchor_type.value) {
                        this.getNativeAnchor({ advertiser_id: advertiser_id.value, anchor_type: anchor_type.value }).then(res => {
                          anchor_id.options = res;
                          anchor_id.value = res.some(opt => opt.value === anchor_id.value) ? anchor_id.value : '';
                        });
                      } else {
                        anchor_id.value = '';
                        anchor_id.options = [];
                      }
                    },
                  },
                },
                anchor_id: {
                  label: '锚点ID',
                  type: 'select',
                  hidden: true,
                  value: '',
                  props: {
                    placeholder: '请选择锚点ID',
                    filterable: true,
                    style: {
                      width: '200px',
                    },
                  },
                  options: [],
                  rules: [
                    { required: true, message: '请选择锚点ID', trigger: ['blur', 'change'] },
                  ],
                },
              },
            },
          },
        },
      },
      // 是否编辑
      is_edit: false,
      /** 小游戏链接弹窗配置 */
      mini_program_info_url_dialog_config: {
        is_show: false,
        dialog_props: {
          title: '请选择小游戏链接',
          width: '800px',
          appendToBody: true,
        },
        getters: {
          getProps: () => {
            const { advertiser_id } = this.ad_form_config.basic_form.config;
            const { micro_app_instance_id } = this.project_info;
            return {
              advertiserId: advertiser_id.value,
              microAppInstanceId: micro_app_instance_id,
            };
          },
        },
      },
    };
  },
  created() {
    this.getMediasList();

    // 是否存在数据
    if (this?.adData?.id) {
      this.is_edit = true;
      getPromotionInfoApi(this.adData.id).then(res => {
        const temp_ad_data = res;

        const map_tuple = [
        // 是否存在小游戏链接
          [
            () => temp_ad_data?.promotion_materials?.mini_program_info?.url,
            () => {
              temp_ad_data.promotion_materials.mini_program_info_url = temp_ad_data.promotion_materials.mini_program_info?.url;
              delete temp_ad_data.promotion_materials.mini_program_info;
            },
          ],
        ];
        map_tuple.forEach(([m, n]) => m() && n());

        for (const key in this.ad_form_config) {
          formDataAssign(
            this.ad_form_config[key].config,
            (key === 'product_info_form' ? temp_ad_data.promotion_materials : temp_ad_data)
          );
        }

        const { promotion_identity, aweme_id } = this.ad_form_config.native_form.config.native_setting.children;
        const { anchor_related_type } = this.ad_form_config.anchor_material_list_form.config;
        const has_aweme_id = !!temp_ad_data?.native_setting?.aweme_id;
        const anchor_related_type_val = temp_ad_data?.native_setting?.anchor_related_type;
        const has_anchor_related_type = !!anchor_related_type_val;

        // 赋值推广身份
        promotion_identity.value = has_aweme_id ? 'TIKTOK' : 'ACCOUNT_INFO';

        // 存在授权账号时即代表推广身份是抖音号
        aweme_id.hidden = !has_aweme_id;

        // 赋值原生锚点 - 原生锚点
        anchor_related_type.value = has_anchor_related_type ? anchor_related_type_val : 'OFF';

        // 赋值原生锚点 - 锚点类型和锚点ID
        if (temp_ad_data?.promotion_materials?.anchor_material_list) {
          const data = temp_ad_data?.promotion_materials?.anchor_material_list[0];
          const { anchor_type, anchor_id } = this.ad_form_config.anchor_material_list_form.config.anchor_material_list.children;
          anchor_type.value = data.anchor_type;
          anchor_id.value = data.anchor_id;
        }

        if (temp_ad_data.promotion_materials) {
          const { material, title } = this.ad_form_config.material_form.config.promotion_materials.children;

          // 图片素材
          if (temp_ad_data.promotion_materials?.image_material_list) {
            material.value.images = temp_ad_data.promotion_materials?.image_material_list?.map(item => {
              return item.images?.map(image_item => {
                return temp_ad_data.local_materials.image[image_item.image_id];
              })[0];
            });
            material.value.tab = 'image';
          }

          // 视频素材
          if (temp_ad_data.promotion_materials?.video_material_list) {
            material.value.videos = temp_ad_data.promotion_materials?.video_material_list?.map(item => {
              const temp_material = temp_ad_data.local_materials.video[item.video_id];

              // 视频封面
              if (item.video_cover_id) {
                temp_material.url[0].thumb_url = temp_ad_data.local_materials.video_cover_id[item.video_cover_id];
              }
              return temp_material;
            });
            material.value.tab = 'video';
          }

          // 产品主图素材
          if (temp_ad_data.promotion_materials?.product_info?.image_ids) {
            const { image_ids } = this.ad_form_config.product_info_form.config.product_info.children;

            // 此时image_ids为array类型，重置image_ids为空的object类型，避免出现$set强行添加对象属性导致image_ids的数据类型不规范问题
            image_ids.value = {};

            this.$set(image_ids.value, 'images', temp_ad_data.promotion_materials?.product_info?.image_ids.map(img_id => {
              return temp_ad_data.local_materials.product[img_id];
            }));

            image_ids.value.tab = 'image';
          }

          // 标题
          if (temp_ad_data.promotion_materials?.title_material_list) {
            title.value.list = temp_ad_data.promotion_materials?.title_material_list.map(item => {
              return {
                name: item.title,
                is_title_pop: false,
              };
            });
          }
        }

        this.initConfig();
      });
    } else {
      this.is_edit = false;
    }
  },
  methods: {
    /**
     * 初始化配置
     */
    async initConfig() {
      let event_list = [];
      for (const key in this.ad_form_config) {
        const config = this.ad_form_config[key]?.config;
        if (config) {
          const change_list = this.getChangeList(config);

          if (change_list.length){
            event_list = [
              ...event_list,
              ...change_list,
            ];
          }
        }
      }

      this.is_loading = true;
      try {
        for (let i = 0; i < event_list.length; i++) {
          await event_list[i]();
        }
      } catch (error) {
        console.log(error);
      }

      this.is_loading = false;
    },

    /**
     * 获取change方法列表
     */
    getChangeList(config) {
      let change_list = [];
      for (const config_key in config) {
        const item = config[config_key];
        if (config[config_key].children) {
          const config_list = this.getChangeList(item.children);
          change_list = [
            ...change_list,
            ...config_list,
          ];
        } else if (item.on?.change){
          change_list.push(item.on.change);
        }
      }

      return change_list;
    },

    onSubmit(params) {
      this.ad_params = {
        ...this.ad_params,
        ...params,
      };
    },

    /**
     * 打开落地页
     * @param {Array<any>} key 键值
     * @param {Array<any>} title 弹框标题
     */
    openLandingPage(key, title) {
      const { advertiser_id } = this.ad_form_config.basic_form.config;
      this.table_box_params.name = `请选择${title}`;
      this.table_box_params.configs = [{
        name: '名称',
        value: 'name',
      },
      {
        name: `链接`,
        value: 'url',
      }];

      this.table_box_params.getTableData = this.getAllPageList;
      this.table_box_params.pullTableData = this.pullAllPageList;
      this.table_box_params.tablep = {
        advertiser_id: advertiser_id.value,
        page: 1,
        limit: 10,
        name: '',
      };
      this.table_box_params.key = key;
      this.table_box_params.is_show = true;
    },

    /**
     * 表格弹框确定回调
     * @param {Array<any>} list
     */
    tableBoxConfirm(list) {
      this.tableBoxCancel();

      const promotion_materials = this.ad_form_config.material_form.config.promotion_materials.children;
      const temp_table_config = promotion_materials[this.table_box_params.key];

      // 不超过列表最大数量
      if (list.length + temp_table_config.value.length <= temp_table_config.props.maxCount) {
        list.forEach(element => {
          temp_table_config.value.push(element.url);
        });
      } else {
        this.$message.warning(`上限为${temp_table_config.props.maxCount}个`);
      }
    },

    // 表格弹框取消回调
    tableBoxCancel() {
      this.table_box_params.is_show = false;
      this.table_box_params.getTableData = null;
    },

    /**
     * 打开素材框
     * @param {string} type 素材类型
     */
    openMaterialBox(type, material_item) {
      if (material_item) {
        material_item.temp_material = null;
        material_item.is_open = true;
        material_item.box_type = type;
        material_item.value.tab = type;
      } else {
        const { material } = this.ad_form_config.material_form.config.promotion_materials.children;
        material.temp_material = null;
        material.is_open = true;
        material.box_type = type;
        material.value.tab = type;
      }
    },

    /**
     * 素材资源确定返回
     * @param {Array<any>} data 返回数据
     * @param {number} type 返回类型
     */
    materialConfirm(data, type) {
      const { material } = this.ad_form_config.material_form.config.promotion_materials.children;

      material.is_open = false;
      if (data.length === 0) {
        return;
      }

      // 更换封面 - 选择多个封面图片，则只保留第一个封面图片
      if (material.temp_material && data.length > 1) {
        data.splice(1);
      }

      // 视频和图片素材不能超过10个！
      const material_const = material.value.images.length + material.value.videos.length;
      if (((material_const + data.length) > material.limit) && !material.temp_material) {
        this.$message.warning(`视频和图片素材不能超过${material.limit}个！`);
        return;
      }

      if (material.value.tab === 'video' && type === 'image') {
        for (let i = 0; i < data.length; i++) {
          const item = data[i];
          if (i === 0) {
            material.temp_material.url[0].thumb_url = item.url[0].url;
          } else {
            const temp_material = JSON.parse(JSON.stringify(material.temp_material));
            temp_material.url[0].thumb_url = item.url[0].url;
            material.value['videos'].push(temp_material);
          }
        }
      } else {
        material.value[type + 's'] = material.value[type + 's'].concat(data);
      }
    },

    /**
     * 产品图片资源确定返回
     * @param {Array<any>} data 返回数据
     * @param {number} type 返回类型
     */
    productInfoConfirm(data, type) {
      const { image_ids } = this.ad_form_config.product_info_form.config.product_info.children;

      image_ids.is_open = false;
      if (data.length === 0) {
        return;
      }

      // 视频和图片素材不能超过10个！
      const material_const = image_ids.value.images.length;
      if ((material_const + data.length) > image_ids.limit) {
        this.$message.warning(`视频和图片素材不能超过${image_ids.limit}个！`);
        return;
      }

      image_ids.value[type + 's'] = image_ids.value[type + 's'].concat(data);
    },

    /**
     *素材资源取消返回
     */
    materialCancel(material) {
      material.is_open = false;
    },

    /**
     * 更换封面
     * @param item 素材项
     */
    replaceCover(item) {
      const { material } = this.ad_form_config.material_form.config.promotion_materials.children;
      material.is_open = true;
      material.box_type = 'image';
      material.temp_material = item;
    },

    /**
     * 取消表单
     */
    onCancelForm() {
      this.$emit('cancel');
    },

    /**
     * 提交表单
     */
    onConfirmForm: async function() {
      let is_succeed = false;
      this.ad_params = {};
      for (let i = 0; i < this.$refs.ad_form.length; i++) {
        const item = this.$refs.ad_form[i];
        is_succeed = await item.confirm();
        if (!is_succeed) {
          break;
        }
      }

      if (is_succeed) {
        this.is_loading = true;

        // 是否存在视频
        if (this.ad_params.promotion_materials.material?.videos?.length) {
          this.ad_params.promotion_materials.video_material_list = this.ad_params.promotion_materials.material?.videos.map(item => {
            return {
              image_mode: item.file_mode.code,
              video_id: item.id,
              video_cover_id: item.url[0].thumb_url,
            };
          });
        }

        // 是否存在图片
        if (this.ad_params.promotion_materials.material?.images?.length) {
          this.ad_params.promotion_materials.image_material_list = this.ad_params.promotion_materials.material?.images.map(item => {
            return {
              image_mode: item.file_mode.code,
              // 图片ID数组，目前仅支持传入1个
              images: [{
                image_id: item.id,
              }],
            };
          });
        }

        // 是否存在标题
        if (this.ad_params.promotion_materials?.title?.list.length) {
          this.ad_params.promotion_materials.title_material_list = this.ad_params.promotion_materials.title?.list.map(item => {
            return {
              title: item.name,
            };
          });
        }

        // 是否存在产品信息
        if (this.ad_params?.product_info) {
          this.ad_params.product_info.image_ids = this.ad_params.product_info.image_ids.images.map(item => item.id);
          this.ad_params.promotion_materials.product_info = this.ad_params.product_info;
        }

        // 是否存在产品信息
        if (this.ad_params?.call_to_action_buttons) {
          this.ad_params.promotion_materials.call_to_action_buttons = this.ad_params.call_to_action_buttons;
        }

        delete this.ad_params.promotion_materials.material;
        delete this.ad_params.promotion_materials.title;
        delete this.ad_params.product_info;
        delete this.ad_params.call_to_action_buttons;

        const { promotion_identity } = this.ad_form_config.native_form.config.native_setting.children;
        const is_tiktok = promotion_identity.value === 'TIKTOK';

        const map_tuple = [
          // 推广身份是否选择抖音号
          [
            () => !is_tiktok,
            () => {
              delete this.ad_params.native_setting;
            },
          ],
          // 是否存在原生锚点
          [
            () => !!this.ad_params?.anchor_related_type,
            () => {
              if (this.ad_params.anchor_related_type !== 'OFF') {
                if (is_tiktok && this.ad_params?.native_setting) {
                  Object.assign(this.ad_params.native_setting, {
                    anchor_related_type: this.ad_params.anchor_related_type,
                  });
                } else {
                  Object.assign(this.ad_params, {
                    native_setting: {
                      anchor_related_type: this.ad_params.anchor_related_type,
                    },
                  });
                }
                if (this.ad_params.anchor_related_type === 'SELECT') {
                  if (this.ad_params?.promotion_materials) {
                    Object.assign(this.ad_params.promotion_materials, {
                      anchor_material_list: [{ ...this.ad_params.anchor_material_list }],
                    });
                  } else {
                    Object.assign(this.ad_params, {
                      promotion_materials: {
                        anchor_material_list: [{ ...this.ad_params.anchor_material_list }],
                      },
                    });
                  }
                }
              }
              delete this.ad_params.anchor_material_list;
              delete this.ad_params.anchor_related_type;
            },
          ],
          // 是否有小游戏链接
          [
            () => this.ad_params?.promotion_materials?.mini_program_info_url,
            () => {
              Object.assign(this.ad_params.promotion_materials, { mini_program_info: { url: this.ad_params.promotion_materials.mini_program_info_url }});
              delete this.ad_params.promotion_materials.mini_program_info_url;
            },
          ],
        ];
        map_tuple.forEach(([m, n]) => m() && n());

        if (this.is_edit) {
          this.ad_params.promotion_id = this.adData.type_id;
          updatePromotionApi(this.adData.id, this.ad_params).then((res) => {
            this.$message.success(res.message);
            this.$emit('confirm');
          }).finally(() => {
            this.is_loading = false;
          });
        } else {
          createPromotionApi(this.ad_params).then((res) => {
            this.$message.success(res.message);
            this.$emit('confirm');
          }).finally(() => {
            this.is_loading = false;
          });
        }
      }
    },

    // 获取落地页
    getAllPageList(params) {
      return new Promise((resolve, reject) => {
        advertisingResource
          .getAllPageList(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 同步落地页
    pullAllPageList(params) {
      return new Promise((resolve, reject) => {
        advertisingResource
          .pullAllPageList(params)
          .then((response) => {
            this.$message.success(response.message);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /** 获取广告账号列表 */
    getMediasList() {
      return getMediasListApi({
        type: 'jrtt',
        is_list: true,
      }).then((res) => {
        const { advertiser_id } = this.ad_form_config.basic_form.config;
        advertiser_id.options = res.list.map((accoun_item) => {
          return {
            label: `${accoun_item.advertiser_id}(${accoun_item.advertiser_name})${accoun_item.note ? ' - ' + accoun_item.note : ''}`,
            value: accoun_item.advertiser_id,
          };
        });
      });
    },

    /**
     * 获取项目选择器列表
     * @param {number} advertiser_id 广告主ID
     */
    getProjectSelector(advertiser_id) {
      const { project_id } = this.ad_form_config.basic_form.config;
      if (advertiser_id) {
        return getProjectSelectorApi({
          advertiser_ids: [advertiser_id],
        }).then((res) => {
          project_id.options = res.list.map((item) => {
            return {
              id: item.id,
              label: item.name,
              value: item.type_id,
            };
          });

          if (project_id) {
            this.getProjectInfo(project_id.value);
          }
        });
      }
    },

    /**
     * 获取项目信息
     * @param {string} _id 项目id
     */
    getProjectInfo(_id) {
      const { project_id } = this.ad_form_config.basic_form.config;
      const index = project_id.options.findIndex((item) => {
        return item.value === _id;
      });

      if (index !== -1) {
        // 获取到项目资源ID进行传参
        const project_source_id = project_id.options[index]?.id;
        return getProjectInfoApi(project_source_id).then((res) => {
          this.project_info = res;
          this.renderForm();
        });
      }
    },

    /**
     * 渲染表单
     */
    renderForm() {
      const { landing_type, download_type, delivery_setting, platform, delivery_mode, micro_promotion_type, micro_app_instance_id } = this.project_info;
      const { bid_type, deep_bid_type, budget_mode, budget_optimize_switch = 'OFF' } = delivery_setting;

      const { budget, cpa_bid, deep_cpabid, roi_goal } = this.ad_form_config.budget_and_bid_form.config;
      const { external_url_material_list, web_url_material_list, mini_program_info_url } = this.ad_form_config.material_form.config.promotion_materials.children;
      const { anchor_related_type } = this.ad_form_config.anchor_material_list_form.config;

      // 【投放模式】是否是自动投放
      const is_procedural = delivery_mode === 'PROCEDURAL';
      // 【竞价策略】是否为最大转化投放
      const is_no_bid = bid_type === 'NO_BID';
      // 【项目预算】是否为日预算
      const is_budget_mode_day = budget_mode === 'BUDGET_MODE_DAY';
      // 【预算择优分配】是否开启
      const is_on = budget_optimize_switch === 'ON';

      if (bid_type) {
        cpa_bid.hidden = is_no_bid;
        deep_cpabid.hidden = !(!is_no_bid && deep_bid_type === 'DEEP_BID_MIN');
        roi_goal.hidden = !(!is_no_bid && deep_bid_type === 'ROI_COEFFICIENT');
      }

      // 广告预算
      const is_all = is_no_bid && is_budget_mode_day && is_on;
      budget.props.min = is_all ? 0 : 300;
      budget.props.disabled = is_all;
      budget.value = is_all ? 0 : (budget.value === 0 ? 300 : budget.value);
      budget.hidden = false;

      if (landing_type === 'APP') {
        external_url_material_list.hidden = download_type !== 'EXTERNAL_URL';
        web_url_material_list.hidden = download_type !== 'DOWNLOAD_URL' || platform !== 'ANDROID';
      }

      /** 推广目标为小游戏时 */
      if (landing_type === 'MICRO_GAME') {
        /** 隐藏Android应用下载详情页 */
        web_url_material_list.hidden = true;
        /** 显示普通落地页 */
        external_url_material_list.hidden = false;
      }

      /** 广告来源 */
      const { source } = this.ad_form_config.additional_creative_info_form.config;
      /** 广告来源，当landing_type = LINK、MICRO_GAME、SHOP时必填 */
      source.rules.required = landing_type === 'MICRO_GAME';

      /** 【投放模式】是自动投放时，不支持【budget】、【cpa_bid】、【deep_cpabid】、【roi_goal】 */
      if (is_procedural) {
        budget.hidden = is_procedural;
        cpa_bid.hidden = is_procedural;
        deep_cpabid.hidden = is_procedural;
        roi_goal.hidden = is_procedural;
      }

      /** 【投放模式】是自动投放时，素材数量上限由10增加为30 */
      this.setMaterialLimit();

      /** 设置【广告预算与出价】显示隐藏 */
      this.ad_form_config.budget_and_bid_form.hidden = budget.hidden && cpa_bid.hidden && deep_cpabid.hidden && roi_goal.hidden;

      /** 【推广目标】是否为小游戏 */
      const is_micro_game = landing_type === 'MICRO_GAME';
      /** 【小游戏类型】是否为字节小游戏 */
      const is_byte_game = micro_promotion_type === 'BYTE_GAME';
      /** 【字节小游戏】是否有值 */
      const is_has_micro_app_instance_id = !!micro_app_instance_id;
      /** 是否为字节小游戏 */
      const is_byte = is_micro_game && is_byte_game && is_has_micro_app_instance_id;
      // 【小游戏链接】显示/隐藏
      mini_program_info_url.hidden = !is_byte;
      // 【落地页】数量限制
      external_url_material_list.props.maxCount = is_byte ? 1 : 10;
      // 【原生锚点】禁选手动选择
      anchor_related_type.options.forEach(opt => opt.value === 'SELECT' && (opt.disabled = is_byte));
      if (is_byte) {
        // 【原生锚点】重置选值
        if (anchor_related_type.value === 'SELECT') {
          anchor_related_type.value = 'OFF';
          anchor_related_type?.on?.change();
        }
      }
    },
    /**
     * 效验所有表单
     * @param is_validate 是否效验数据
     * @param is_filter_empty 是否过滤空值
    */
    async validateAllForm(is_validate = false, is_filter_empty = false) {
      let valid = true;
      for (let i = 0; i < this.$refs.ad_form.length; i++) {
        const item = this.$refs.ad_form[i];
        const is_successed = await item.confirm(is_validate, is_filter_empty);
        if (!is_successed) {
          valid = is_successed;
        }
      }
      return valid;
    },
    /**
     * 打开模板弹窗
     * @param {string} type 模板类型
     */
    async openTemplateDialog(type) {
      this.ad_params = {};
      const is_validate = await this.validateAllForm();
      Object.assign(this.template_dialog_config, { is_show: true, is_validate, type, name: '' });
    },
    /** 模板弹窗确认 */
    async confirmTemplateDialog() {
      if (!this.template_dialog_config.name) {
        this.$message.warning('请输入模板名称！');
        return;
      }
      const { type, name } = this.template_dialog_config;
      const params = {
        advertiser: 'jrtt',
        type,
        name,
        template_data: JSON.stringify({ ...this.ad_params }),
      };
      templateResource.addTemplateData(params).then(res => {
        this.$message.success(res.message || '保存成功！');
      });
      this.template_dialog_config.is_show = false;
    },
    /**
     * 打开模板列表
     * @param {string} type 模板类型
     */
    openTemplateList(type) {
      Object.assign(this.template_list_config, { is_show: true, type });
    },
    /**
     * 应用模板
     * @param {string} template_data 模板数据
     */
    async applicationTemplate(template_data) {
      const data = template_data.split(' - ')[1];
      this.template_list_config.is_loading = true;
      const template_data_sources = JSON.parse(data);

      Object.keys(this.ad_form_config).forEach(key => {
        const item = this.ad_form_config[key];
        item?.config && formDataAssign(item.config, template_data_sources);
      });

      // 推广身份
      const { promotion_identity, aweme_id } = this.ad_form_config.native_form.config.native_setting.children;
      const get_aweme_id = template_data_sources?.native_setting?.aweme_id;
      const has_aweme_id = get_aweme_id === '' || !!get_aweme_id;
      promotion_identity.value = has_aweme_id ? 'TIKTOK' : 'ACCOUNT_INFO';
      aweme_id.hidden = !has_aweme_id;

      await this.initConfig();
      Object.assign(this.template_list_config, { is_loading: false, is_show: false });
    },

    /** 获取广告主绑定的抖音号 */
    getTikTokAccount(advertiser_id) {
      return new Promise((resolve, reject) => {
        advertisingResource
          .getTikTokAccountApi({ advertiser_id })
          .then((response) => {
            const format_data = response.map(e => {
              return {
                label: `${e.aweme_name}(${e.aweme_id})`,
                value: e.aweme_id,
              };
            });
            resolve(format_data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /** 获取授权账号选项 */
    getAwemeIdOptions(advertiser_id) {
      const { aweme_id } = this.ad_form_config.native_form.config.native_setting.children;
      if (advertiser_id) {
        aweme_id.props.loading = true;
        aweme_id.options.splice(0);
        this.getTikTokAccount(advertiser_id).then(res => {
          aweme_id.options = res;
        }).finally(() => {
          aweme_id.props.loading = false;
          aweme_id.value = aweme_id.options.some(opt => opt.value === aweme_id.value) ? aweme_id.value : '';
        });
      } else {
        aweme_id.options.splice(0);
        aweme_id.value = '';
      }
    },

    /** 获取广告主的原生锚点ID */
    getNativeAnchor(data) {
      return new Promise((resolve, reject) => {
        // 获取锚点列表之前先同步一次
        nativeAnchor.pullNativeAnchorApi({ advertiser_id: data.advertiser_id })
          .finally(() => {
            nativeAnchor
              .getNativeAnchorApi(data)
              .then((response) => {
                const format_data = response.list.map(e => {
                  return {
                    label: `${e.name}(${e.type_id})`,
                    value: e.type_id,
                  };
                });
                resolve(format_data);
              })
              .catch((error) => {
                reject(error);
              });
          });
      });
    },

    /** 打开小游戏链接弹窗 */
    openMiniProgramInfoUrl() {
      this.mini_program_info_url_dialog_config.is_show = true;
    },

    /**
     * 确认小游戏链接弹窗
     * @param {Object} data 小游戏链接数据
     */
    miniProgramInfoUrlConfirm(data) {
      this.mini_program_info_url_dialog_config.is_show = false;
      const { mini_program_info_url } = this.ad_form_config.material_form.config.promotion_materials.children;
      mini_program_info_url.value = data.link;
    },

    /**
     * 设置素材数量上限
     * @returns {void}
     */
    setMaterialLimit() {
      const { delivery_mode } = this.project_info;
      // 【投放模式】是否是自动投放
      const is_procedural = delivery_mode === 'PROCEDURAL';
      const { material } = this.ad_form_config.material_form.config.promotion_materials.children;
      material.limit = is_procedural ? 30 : 10;
    },
  },
};
</script>

<style>
.project-create {
  padding-bottom: 60px;
}

.floor-button {
  position: absolute;
  padding: 20px;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: right;
  z-index: 99;
  border-top: 1px solid #ccc;
  background-color: #fff;
}
</style>

<style lang="scss">
.jrtt-ad-create-container {
  label[for="promotion_materials.children.mini_program_info_url.value"] {
    &+.el-form-item__content {
      display: flex;
    }
  }
}
</style>
